import { handleClickCard } from "../../../functions/functions";

/**
 * Componente reutilizable para el botón de apuesta "Juega aquí"
 */
export default function ButtonSponsored({ url, patrocinador = "", wrapperClass = "", buttonClass = "" }) {
  // No renderiza nada si no hay URL válida
  const isValidUrl = typeof url === "string" && url.trim().length > 0;
  if (!isValidUrl) return null;

  // Se obtiene la metadata específica del patrocinador
  const patrocinadorKey = patrocinador.trim().toLowerCase();
  const fullButtonClass = `button-${patrocinadorKey} ${buttonClass}`.trim();

  return (
    <div className={wrapperClass}>
      <button type="button" onClick={(e) => handleClickCard(e, url)} className={fullButtonClass} title={url} aria-label="Botón para apostar en el sitio del patrocinador">
        Juega aquí
      </button>
    </div>
  );
}